import type { SVGProps } from 'react';
const SvgIconInvesting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.75 2a2.25 2.25 0 0 0-1.712 3.71l-1.645 2.84a2.26 2.26 0 0 0-1.275.096l-1.09-1.264a2.25 2.25 0 1 0-3.78.17L2.842 9.579A2.253 2.253 0 0 0 0 11.75a2.25 2.25 0 1 0 4.075-1.316l1.398-2.018a2.25 2.25 0 0 0 1.412-.063l1.088 1.262a2.25 2.25 0 1 0 3.697-.276l1.666-2.877q.202.038.414.038a2.25 2.25 0 0 0 0-4.5M13 4.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-7.667 2a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M2.25 11a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.667-1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconInvesting;
